import React from 'react';
import styled from 'styled-components';
import { POCValue } from 'screens/student-details/styled-comps';
import { Row, FlexView, COLORS, toRGBA } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

import { getDateOfRequest } from 'utils/student-transfer';

const Root = styled(FlexView)`
  gap: 16px;
  padding: 8px 0px;
`;

const InfoWrapper = styled(FlexView)`
  width: 320px;
  gap: ${({ gap }) => gap || '16'}px;
`;

const NameCardWrapper = styled(Row)`
  gap: 16px;
  margin-top: ${({ marginTop }) => marginTop};
`;

const NameCard = styled(Text)`
  min-width: 152px;
  line-height: 20px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  width: auto;
  font-weight: 700;
`;

const getSearchingTeacherData = data => {
  const {
    studentName,
    teacherName,
    grade,
    region,
    classBalance,
    tenureEndDate,
    candidateTeacherName,
  } = data || {};

  return [
    {
      title: 'Student',
      value: studentName,
    },
    {
      title: 'Teacher',
      value: teacherName,
    },
    {
      title: 'Grade',
      value: grade,
    },
    {
      title: 'Region',
      value: region,
    },
    {
      title: 'Class Balance',
      value: classBalance,
    },
    {
      title: 'Tenure end date',
      value: getDateOfRequest(tenureEndDate) || '-',
    },
    {
      title: 'Requested teacher',
      value: candidateTeacherName,
    },
  ];
};

const SearchingTeacherDetails = ({ data }) => {
  const { studentName } = data || {};
  const searchTeacherData = getSearchingTeacherData(data);

  return (
    <Root>
      <InfoWrapper>
        {searchTeacherData.map(item => {
          const { title, value } = item || {};

          return (
            <NameCardWrapper key={title} alignItems="center">
              <NameCard variant="eyebrow2" color={toRGBA(COLORS.COLA, 0.75)}>
                {title}
              </NameCard>
              <POCValue variant="cta1">{value || '-'}</POCValue>
            </NameCardWrapper>
          );
        })}
      </InfoWrapper>

      <Text variant="body1Regular">
        We're actively searching for the perfect teacher for {studentName || 'Champ'}'s
        math needs
      </Text>
    </Root>
  );
};

export default SearchingTeacherDetails;
